import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Close } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import Chip from './Chip';
import './styles.scss';

class TextChip extends PureComponent {
    state = {};

    render() {
        const {
            text = '',
            className = '',
            onClick = () => null,
            isDismissible = true,
            onClickDismissible = () => null,
        } = this.props;

        const classes = ['react-chip-text'];
        if (className) {
            classes.push(className);
        }
        if (isDismissible) {
            classes.push('react-chip-dismissible');
        }

        return (
            <Chip className={classes.join(' ')} onClick={onClick}>
                <div className="chip-text">{text}</div>
                {isDismissible && (
                    <div
                        role="button"
                        tabIndex="-1"
                        className="chip-dismissible"
                        onClick={onClickDismissible}
                    >
                        <Close color={CFM_STONE} />
                    </div>
                )}
            </Chip>
        );
    }
}

TextChip.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    isDismissible: PropTypes.bool,
    onClickDismissible: PropTypes.func,
};

export default TextChip;
